import { createFileRoute } from "@tanstack/react-router";

import { DatasetBrowser } from "@/features/assets/DatasetBrowser";

export const Route = createFileRoute("/_authenticated/benchmark/concepts")({
  component: () => (
    <DatasetBrowser datasetId="benchmark" defaultVersionId="20260604" focusFileKey="concepts" />
  ),
});
